import React from 'react';
import { createRoot } from 'react-dom/client';

// AOS Animation Library
import 'aos/dist/aos.css';

// User's Custom Styles
import './styles/index.css';
import './styles/App.css';
import './styles/Header.css';
import './styles/Footer.css';
import './styles/Hero.css';
import './styles/Breadcrumbs.css';
import './styles/Newsletter.css';
import './styles/FeaturedNews.css';
import './styles/LoadingSpinner.css';
import './styles/Home.css';
import './styles/About.css';
import './styles/Contact.css';
import './styles/News.css';
import './styles/NewsDetail.css';
import './styles/NotFound.css';
import './styles/Sectors.css';
import './styles/SectorPage.css';
import './styles/UnifiedSectorPage.css';
import './styles/Responsive.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
